import { useContext } from 'react';
import { BaleInboundContext } from './context';

export const useBaleInboundContext = () => {
	const context = useContext(BaleInboundContext);
	if (!context) {
		throw new Error('useBaleInboundContext must be used within a BaleInboundContextProvider');
	}
	return context;
};
